//Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --Start
import dayjs from "dayjs";
import { memo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useLocation } from "react-router";
import { _commaFormatter } from "../../controllers";

const FiiMfTable = ({ trayExpanded, fiData, ...props }) => {
    const location = useLocation()
    return (
        <Container fluid className='p-0'>           
            <Row className='g-0 my-3'>               
                <Col>
                    <div className='font-regular font-size2 color-subtext px-2'>*All values are in Crores</div>
                </Col>               
            </Row>            
            <div className={`${location.pathname === "/dashboard" ? "scanners-table-container pe-1" : trayExpanded ? 'scanners-side-tray-table-expand-container pe-1' : 'scanners-side-tray-table-container pe-1'}`}>
                {fiData?.length > 0 && fiData?.map(data => (                                       
                    <div className='table-responsive mb-2'>
                       <table className='table table-hover table-striped scanners-table bdr'>
                          <thead>
                            <tr>
                                {[data?.FIIDate, 'Gross Purchase', 'Gross Sales', 'Net Investment', 'Cumulative Net Investment']?.map((element, i) =>
                                    <th className='font-regular font-size1 table-th-color-text text-center col-2 text-truncate bdr-rgt'>
                                        {element === data?.FIIDate ? dayjs(element)?.format('DD MMM \'YY') : element}
                                    </th>
                                )}
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                                <td className='font-regular font-size1 table-td-color-subtext text-center text-uppercase col-md-2 bdr-rgt'>Equity</td>
                                <td className='font-regular font-size1 table-td-color-subtext text-center text-uppercase col-md-2 bdr-rgt'>{_commaFormatter(data?.EquityGrossPurchase)}</td>
                                <td className='font-regular font-size1 table-td-color-subtext text-center text-uppercase col-md-2 bdr-rgt'>{_commaFormatter(data?.EquityGrossSales)}</td>
                                <td className='font-regular font-size1 table-td-color-subtext text-center text-uppercase col-md-2 bdr-rgt'>{_commaFormatter(data?.EquityNetInvestment)}</td>
                                <td className='font-regular font-size1 table-td-color-subtext text-center text-uppercase col-md-2'>{_commaFormatter(data?.EquityCumulativeNetInvestment)}</td>
                            </tr>
                            <tr>
                                <td className='font-regular font-size1 table-td-color-subtext text-center text-uppercase col-md-2 bdr-rgt'>Debt</td>
                                <td className='font-regular font-size1 table-td-color-subtext text-center text-uppercase col-md-2 bdr-rgt'>{_commaFormatter(data?.DebtGrossPurchase)}</td>
                                <td className='font-regular font-size1 table-td-color-subtext text-center text-uppercase col-md-2 bdr-rgt'>{_commaFormatter(data?.DebtGrossSales)}</td>
                                <td className='font-regular font-size1 table-td-color-subtext text-center text-uppercase col-md-2 bdr-rgt'>{_commaFormatter(data?.DebtNetInvestment)}</td>
                                <td className='font-regular font-size1 table-td-color-subtext text-center text-uppercase col-md-2'>{_commaFormatter(data?.DebtCumulativeNetInvestment)}</td>
                            </tr>
                             
                         </tbody>    
                       </table>                     
                   </div>  
                ))
                }
            </div>
        </Container>
    );
};

export default memo(FiiMfTable);
//Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --End